import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom'
import Cookies from 'universal-cookie';
const cookies = new Cookies()

const PublicRoute = ({ children }: any) => {
    const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
    const authToken = cookies.get('skyToken')
    const location = useLocation();
    const loggedIn = !!isAuthenticated?.isLogin && !!authToken;
    if (!loggedIn) return children;

    const mustChange = isAuthenticated?.changePassword === true;
    const onChangePassword =
        location.pathname.toLowerCase() === "/change/password";
    if (mustChange) {
        return onChangePassword ? (
            children
        ) : (
            <Navigate to="/change/password" replace />
        );
    }
    return <Navigate to="/" replace />;
}

export default PublicRoute